// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Phone/Phones/mutation-send-appointment-reminder.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Profile_Content_ContactInfo_Phone_Phones(
  $appointment_booking_id: numeric!
  $communication_preference_id: numeric!
) {
  comms_send_appointment_booking_reminder(
    appointment_booking_id: $appointment_booking_id
    communication_preference_id: $communication_preference_id
  ) {
    ok
  }
}

`